import { VStack, Text } from '@bpba/ui-components';
import React from 'react';

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <VStack px={[16, null, null, 50]} py={[24, null, null, 32]}>
          <Text fontSize={[26, null, null, 8]} color="primary.0" lineHeight={['32px', null, null, '43px']}>
            Ha ocurrido un problema
          </Text>
          <Text fontSize={[1, null, 2]} lineHeight={['18px', null, '21px']}>
            Por favor, intente más tarde. Gracias por confiar en nosotros.
          </Text>
        </VStack>
      );
    }
    return this.props.children;
  }
}
